<tr>
  <td>{{children.name}}</td>
  <td>fsdfsdfsd</td>
  <td>{{children.dealerPrice}}</td>
  <td>{{children.customerPrice}}</td>
  <td>
    <a class="btn btn-lg btn-primary btn-icon ripple light ms-1" routerLink="/back-office/option/{{children.id}}">
      <i class="fa fa-pencil"></i>
    </a>
    <a class="btn btn-lg btn-primary btn-icon ripple light ms-1" routerLink="/back-office/option/{{children.id}}/show">
      <i class="fa fa-eye"></i>
    </a>
    <a class="btn btn-lg btn-primary btn-icon ripple light ms-1"

    >
      <i class="fa fa-remove"></i>
    </a>
  <td>
</tr>
<ng-container  *ngFor="let child of children.options;let i=index">
  {{i}}
   <app-child-item [children]="child"></app-child-item>
 </ng-container>


